import { useQuery } from '@tanstack/react-query'
import { useLoanSummaryOptions } from './useLoanSummaryOptions'

export const useLoanSummary = (isExisting: boolean) => {
  const options = useLoanSummaryOptions(isExisting)
  return useQuery(options)
}
